import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconHome20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconHome20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m10.004 1.979.46.357 7.694 5.97a.75.75 0 0 1-.92 1.184L17 9.306V15.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 15.5V9.312l-.23.178a.75.75 0 0 1-.92-1.185l7.694-5.97zm0 1.899L15.5 8.142V15.5a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1V8.148zM7.807 9.824c.254-.26.416-.307.466-.317a.37.37 0 0 1 .213.024 1.1 1.1 0 0 1 .384.249l.008.008a1.5 1.5 0 0 0 2.214 0l.008-.008a1.1 1.1 0 0 1 .384-.249.37.37 0 0 1 .212-.024c.05.01.212.057.466.317.323.33.344.574.278.857-.091.397-.393.914-.907 1.492-.49.551-1.07 1.046-1.548 1.414a11.5 11.5 0 0 1-1.549-1.414c-.514-.578-.816-1.095-.907-1.492-.065-.283-.044-.527.278-.857m2.178-1.049s.121-.137.334-.296c.545-.407 1.69-.959 2.916.296 2.786 2.85-3.25 6.651-3.25 6.651s-6.036-3.8-3.25-6.65c1.226-1.256 2.37-.704 2.916-.297.212.16.334.296.334.296"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconHome20);
